import List from './List';
class ListManager {
    storage;
    lists;
    constructor(storage) {
        this.storage = storage;
        this.lists = this.loadLists();
    }
    loadLists() {
        const lists = this.storage.get('lists');
        return lists ?? [];
    }
    getLists() {
        return this.lists;
    }
    getList(listId) {
        return this.lists.find((list) => list._id === listId);
    }
    saveList(title, color) {
        const newList = new List(title, color);
        this.lists.push(newList);
        this.storage.save('lists', this.lists);
        return newList;
    }
    deleteList(listId) {
        const index = this.lists.findIndex((list) => list._id === listId);
        if (index === -1)
            return null;
        const deletedList = this.lists.splice(index, 1)[0];
        this.storage.save('lists', this.lists);
        return deletedList;
    }
}
export default ListManager;
